
import React from 'react';
import {Elements} from 'react-stripe-elements';

import InjectedCheckoutForm from './CheckoutForm';

class MyStoreCheckout extends React.Component {
    render() {
        return (
            <Elements>
                <InjectedCheckoutForm paymentClient = {this.props.paymentClient}
                                      userDetails={this.props.userDetails}
                                      openMessageDialog = {this.props.openMessageDialog}
                                      orderTotal = {this.props.orderTotal}
                                      userId={this.props.userId}
                                      cartItemIds= {this.props.cartItemIds}
                                      paymentId={this.props.paymentId}
                                      discount ={this.props.discount}/>
            </Elements>
        );
    }
}

export default MyStoreCheckout;


// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderConfirmationBottom/StripeComponents/MyStoreCheckout.js